module.exports = __webpack_public_path__ + "img/LsgAudio2-4.763b5864.jpeg";